export const brandLogos = [
  {
    name: "Chitale Bandhu",
    logo: "/lovable-uploads/41280c10-a828-464d-994d-0c6f87a546f5.png"
  },
  {
    name: "The Cake Carnival",
    logo: "/lovable-uploads/63cbb375-1fde-4742-a4b0-f0d922356ee9.png"
  },
  {
    name: "Crazy Cheesy",
    logo: "/lovable-uploads/af791dc0-6fc8-401f-8560-023b498a6246.png"
  },
  {
    name: "Dwarkadas Shamkumar Textiles",
    logo: "/lovable-uploads/c1491f40-2887-4a01-b200-5a8c82750d0d.png"
  },
  {
    name: "KNS",
    logo: "/lovable-uploads/6453ff1d-d1b5-4980-8783-12cbe49a6b84.png"
  },
  {
    name: "Solaris Sports & Fitness",
    logo: "/lovable-uploads/2f380edd-01b3-4baa-8553-071a0c0cfee9.png"
  },
  {
    name: "Mrudul Hearing Aid Centre",
    logo: "/lovable-uploads/88a99149-625d-47dc-8126-2a0b10da8ddd.png"
  },
  {
    name: "Ranka Jewellers",
    logo: "/lovable-uploads/ranka logo.webp"
  },
  {
    name: "Ocakes",
    logo: "/lovable-uploads/ocakes logo.png"
  },
  {
    name: "Kekiz",
    logo: "/lovable-uploads/kekiz.png"
  },
  {
    name: "Go Best",
    logo: "/lovable-uploads/go best.webp"
  },
  {
    name: "Sapphire",
    logo: "/lovable-uploads/sapphire logo.jpeg"
  },
  {
    name: "Syspree",
    logo: "/lovable-uploads/syspree logo.webp"
  },
  {
    name: "Digitiz Matrix",
    logo: "/lovable-uploads/digitiz matrix logo.png"
  },
  {
    name: "LeadstoSell",
    logo: "/lovable-uploads/LeadstoSell logo.webp"
  },
  {
    name: "The Scribblers",
    logo: "/lovable-uploads/the scribblers logo.png"
  },
  {
    name: "Webdudes",
    logo: "/lovable-uploads/Webdudes.png"
  },
  {
    name: "Meridian",
    logo: "/lovable-uploads/Meridian logo.png"
  },
  {
    name: "Osteon",
    logo: "/lovable-uploads/Osteon logo.png"
  },
  {
    name: "Ugaoo",
    logo: "/lovable-uploads/Ugaoo logo.png"
  },
  {
    name: "NIC Ice Creams",
    logo: "/lovable-uploads/NIC Ice Creams logo.png"
  },
  {
    name: "Kiga Ice Creams",
    logo: "/lovable-uploads/Kiga Ice Creams logo.png"
  },
  {
    name: "Nidan",
    logo: "/lovable-uploads/Nidan logo.png"
  },
  {
    name: "Dr. Tayade",
    logo: "/lovable-uploads/Dr. Tayade logo.jpg"
  },
  {
    name: "Colours Pre School",
    logo: "/lovable-uploads/Colours Pre School logo.png"
  },
  {
    name: "24 Arc Media",
    logo: "/lovable-uploads/24 Arc Media logo.jpeg"
  },
  {
    name: "Geniebee",
    logo: "/lovable-uploads/Geniebee.jpg"
  },
  {
    name: "Digital Tokri",
    logo: "/lovable-uploads/Digital Tokri logo.png"
  },
  {
    name: "Brainmines",
    logo: "/lovable-uploads/Brainmines logo.jpeg"
  },
  {
    name: "iVenus",
    logo: "/lovable-uploads/iVEnus (1).png"
  }
];